module.exports = __webpack_public_path__ + "img/Einzeldiagnose_Rechnung_Taifun_A.df245eee.png";